import { useEffect, useState } from 'react';

const useCurrentOffsetEffect = (
  callback,
  documentRef,
  pdfDimensions,
  addedFormFields,
  item,
  displacement,
  pdfIndividualPageDetails,
) => {
  const [closestCoordinatesData, setClosestCoordinatesData] = useState(null);

  function getClosestXorY(
    currentOffset,
    documentRef,
    pdfDimensions,
    pdfIndividualPageDetails,
  ) {
    const rect = documentRef.current.getBoundingClientRect();
    const x = currentOffset?.x - rect.left - 16;
    const y =
      currentOffset.y -
      rect.top -
      16 -
      displacement * pdfDimensions.scale +
      documentRef.current?.scrollTop;

    let pageIndex = 0;
    let yPositionInPage = JSON.stringify(JSON.parse(y));

    for (let i = 0; i < pdfIndividualPageDetails.length; i++) {
      const pageHeight =
        pdfIndividualPageDetails?.[i].height * pdfDimensions.scale;
      const adjustedPageHeight = pageHeight + 16;

      if (yPositionInPage > adjustedPageHeight) {
        pageIndex++;
        yPositionInPage -= adjustedPageHeight;
      } else {
        break; // Exit the loop if the yPositionInPage is within this page
      }
    }

    let activePageTop = 0;
    for (let i = 0; i < pageIndex; i++) {
      const pageHeight =
        pdfIndividualPageDetails?.[i]?.height + 16 / pdfDimensions.scale;
      activePageTop += pageHeight;
    }

    const scaledX = x / pdfDimensions.scale;
    const scaledY = y / pdfDimensions.scale;
    const pageNumber = pageIndex + 1;

    const FieldsInPage =
      addedFormFields
        ?.filter((x) => x.id !== item.id)
        ?.filter((x) => x.formField.pageNumber === pageNumber)
        ?.map((y) => y.placeholder) || [];

    const allXCoordinates = FieldsInPage.map((coordinate) => coordinate.x); //all possible x coordinates
    const allYCoordinates = FieldsInPage.map(
      (coordinate) => coordinate.y + activePageTop,
    ); //all possible y coordinates
    let closestX;
    let closestY;
    if (allXCoordinates && allXCoordinates.length > 0) {
      closestX = allXCoordinates.reduce((prev, curr) =>
        Math.abs(curr - scaledX) < Math.abs(prev - scaledX) ? curr : prev,
      );
    } else {
      closestX = null;
    }

    if (allYCoordinates && allYCoordinates.length > 0) {
      closestY = allYCoordinates.reduce((prev, curr) =>
        Math.abs(curr - scaledY) < Math.abs(prev - scaledY) ? curr : prev,
      );
    } else {
      closestY = null;
    }
    const differenceFromClosestX = Math.abs(closestX - scaledX);
    const differenceFromClosestY = Math.abs(closestY - scaledY);

    const reverseScaledClosestX = closestX * pdfDimensions.scale + rect.left;
    const reverseScaledClosestY =
      closestY * pdfDimensions.scale +
      rect.top +
      16 +
      displacement * pdfDimensions.scale -
      documentRef.current?.scrollTop;
    return {
      closestX: closestX,
      showX: differenceFromClosestX < 2,
      closestY,
      showY: differenceFromClosestY < 2,
      pageIndex,
      reverseScaledClosestX,
      reverseScaledClosestY,
      activePageTop,
    };
  }

  useEffect(() => {
    const updateState = () => {
      const currentOffset = callback();
      if (currentOffset) {
        const newClosestCoordinatesData = getClosestXorY(
          currentOffset,
          documentRef,
          pdfDimensions,
          pdfIndividualPageDetails,
        );
        setClosestCoordinatesData(newClosestCoordinatesData);
      }
    };

    const intervalId = setInterval(updateState, 10); // You can adjust the interval as needed
    return () => clearInterval(intervalId);
  }, [callback, documentRef, pdfDimensions, closestCoordinatesData]);

  return closestCoordinatesData;
};

export default useCurrentOffsetEffect;
